import { MSelector, MUser } from '@argalis-apps/models';

export const TEST_IResponsable_Administratif: MUser.IClient[] = [
  {
    id: 10,
    name: 'Nouvel utilisateur'
  },
  {
    id: 20,
    name: 'pierro'
  }
];
